import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { Action, PageHeading } from '../components/Common';
import { DeleteDialog } from '../components/DeleteDialog';
import { TicketFilters } from '../components/tickets/TicketFilters';
import { TicketResults } from '../components/tickets/TicketResults';
import { useTicketLog } from '../hooks/useTicketLog';

export default function Tickets() {
  const navigate = useNavigate();
  const state = useTicketLog();
  const create = () => navigate('/');
  const openCount = state.tickets.length - (state.counts.resolved || 0);
  return <div className="page-enter">
    <PageHeading eyebrow="EVERY CONVERSATION, ACCOUNTED FOR." title="Ticket log" subtitle={`${state.tickets.length} conversations · ${openCount} open`} action={<Action data-testid="tickets-new-ticket-button" onClick={create}><Plus size={16}/>New ticket</Action>}/>
    <TicketFilters state={state}/>
    {state.error && <div data-testid="tickets-error" className="page-error" role="alert">{state.error}<button data-testid="tickets-retry-button" onClick={state.refresh}>Retry</button></div>}
    <TicketResults state={state} onCreate={create}/>
    <DeleteDialog open={Boolean(state.deleting)} busy={state.busy} prefix="delete-ticket" title={`Delete ${state.deleting?.number}?`} description="This conversation, its draft, and feedback will be permanently removed. This can’t be undone." cancelLabel="Keep ticket" confirmLabel="Delete ticket" onCancel={() => state.setDeleting(null)} onConfirm={state.remove}/>
  </div>;
}